import Shimmer from "@components/core/Shimmer/Shimmer";
import ShimmerWrapper from "@components/core/Shimmer/ShimmerWrapper";

const EvaluationSkeleton = () => {
    return (
        <ShimmerWrapper spacing={16} direction='column' align='flex-start'>
            {Array.from({ length: 4 }).map((_, index) => (
                <ShimmerWrapper key={index} spacing={16} direction='row' align='flex-start' justify='space-between'>
                    <ShimmerWrapper spacing={16} direction='column' align='flex-start'>
                        <Shimmer width={130} height={12} radius={6} />
                        <Shimmer width={100} height={12} radius={6} />
                    </ShimmerWrapper>
                    <ShimmerWrapper spacing={16} direction='row' align='flex-start'>
                        {Array.from({ length: 6 }).map((_, index) => (
                            <ShimmerWrapper key={index} spacing={16} width="100%" direction='row' align='flex-start' justify='flex-start'>
                                <Shimmer width={100} height={18} radius={6} />
                            </ShimmerWrapper>
                        ))}
                    </ShimmerWrapper>
                </ShimmerWrapper>
            ))}

            {Array.from({ length: 2 }).map((_, index) => (
                <ShimmerWrapper padding="20px" key={index} spacing={16} direction='column' align='flex-start' justify='space-between' border>
                    <ShimmerWrapper spacing={16} direction='row' align='flex-start' justify='space-between'>
                        <Shimmer width={130} height={32} radius={6} />
                        <Shimmer width={130} height={32} radius={6} />
                    </ShimmerWrapper>
                    <ShimmerWrapper spacing={16} direction='column' align='flex-start'>
                        {Array.from({ length: 8 }).map((_, index) => (
                            <ShimmerWrapper key={index} spacing={16} width="100%" direction='row' align='flex-start' justify='flex-start'>
                                <Shimmer width="20%" height={36} radius={6} />
                                <Shimmer width="60%" height={36} radius={6} />
                                <Shimmer width="20%" height={36} radius={6} />
                            </ShimmerWrapper>
                        ))}
                    </ShimmerWrapper>
                </ShimmerWrapper>
            ))}
        </ShimmerWrapper>
    );
}

export default EvaluationSkeleton;